import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@material-ui/core";
import { useLocale } from "@hooks";

export type AlertDialogProps = {
  open: boolean;
  title?: string;
  onOk: () => void;
  onClose: () => void;
  okText?: string;
  cancelText?: string;
  children?: React.ReactNode;
  loading?: boolean;
  hideCancel?: boolean;
};

export function AlertDialog(props: AlertDialogProps) {
  const { locale } = useLocale();
  const { okText = locale.OK, cancelText = locale.Cancel } = props;

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      {props.title && <DialogTitle>{props.title}</DialogTitle>}

      {props.children && (
        <DialogContent>
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {props.children}
          </Typography>
        </DialogContent>
      )}

      <DialogActions>
        {!props.hideCancel && (
          <Button
            onClick={() => {
              props.onClose();
            }}
            color="secondary"
            variant="outlined"
          >
            {cancelText}
          </Button>
        )}

        <Button
          onClick={() => {
            props.onOk();
          }}
          color="primary"
          variant="contained"
          disabled={props.loading}
        >
          {okText}
          {props.loading ? (
            <CircularProgress
              color="secondary"
              size="16px"
              style={{ marginLeft: "8px" }}
            />
          ) : (
            ""
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlertDialog;
